import type { PlatformsListRow } from "@/admin/entities/platforms";
import type { PlatformsListQueryType } from "@/types/graphql/admin.generated";

/**
 * Мапперы для feature управления платформами
 * Используют конкретные типы из GraphQL кодгена
 */

// Трансформация данных GraphQL ответа в формат для таблицы
// CRUD компонент ожидает (data: unknown) => TableData<Row>
export function getTableData(data: unknown): {
  nodes: PlatformsListRow[];
  count: number;
} {
  const platforms = (data as PlatformsListQueryType)?.platforms;

  if (!platforms || !platforms.nodes) {
    return { nodes: [], count: 0 };
  }

  return platforms;
}

// Маппинг данных платформы в формат для отображения в таблице
export function mapColumns(platform: PlatformsListRow) {
  return [
    [platform.title, platform.id], // Title
    [platform.status], // Status
    [platform.published], // Published
    [platform.title, platform.logo], // Logo
    [platform.host, platform.slugHost, platform.slugUrl, platform.url], // Host
    [platform.id], // id (скрытая колонка)
  ];
}
